var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.progress)?_c('div',{staticClass:"progress"},[_c('div',{style:({ width: this.progress + '%' })})]):_vm._e(),_c('sidebar'),_c('main',[_c('router-view'),(_vm.isExecEnabled && _vm.isLogged && _vm.user.perm.execute)?_c('shell'):_vm._e()],1),_c('prompts'),_c('upload-files')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }